import React from 'react';
import { colors, Typography } from 'kangarootime-ui';
import InformationCard from '../InformationCard';
import { capitalize } from '../../../../utils/string';

const TodaysMenu = ({ menu, isLoading }) => {
  const { meals } = menu;

  return (
    <InformationCard title='Menu' color={colors.coral} isLoading={isLoading}>
      { meals.map((meal, index) => {
        const { formattedMealtime, foods } = meal;
        // need the split, map, join inside the first map so that food items with a space are capitalized properly; ex: Apple Juice
        const capitalizedFoods = foods.map(food => food.split(' ').map(f => capitalize(f)).join(' ')).join(', ');

        return (
          <div key={index}>
            <Typography style={{ fontSize: '0.875rem', lineHeight: 'normal', color: '#5F5F5F' }}>{formattedMealtime}: {capitalizedFoods}</Typography>
          </div>
        );
      })}
    </InformationCard>
  );
};

export default TodaysMenu;
